<template>
  <div class="wrapper">
    <div class="balance">
      <span>可用余额</span>
      <span class="money">{{userInfo.balance}}元</span>
      <span class="recharge">
        <router-link :to="{name:'recharge'}">充值</router-link>
      </span>
    </div>
    <div class="detail">
      <div class="detail-title">余额明细</div>
      <el-table :data="tableData" style="width: 100%" v-if="tableData.length>0">
        <el-table-column prop="ctime" label="时间" width="200" align="center"></el-table-column>
        <el-table-column prop="money" label="金额" width="200" align="center"></el-table-column>
        <el-table-column prop="type" label="操作" align="center"></el-table-column>
        <el-table-column prop="balance" label="余额" align="center"></el-table-column>
      </el-table>
      <div v-else class="detail-nodata">您还没有任何收支明细记录哦</div>
    </div>
    <div v-if="tableData.length>0">
      <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  name: "Balance",
  components: { Pagination },
  props: {},
  data() {
    return {
      userInfo: {},
      page: 1,
      limit: 10,
      totalPage: 0,
      tableData: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.$storage.set("userInfo", result.data);
          this.userInfo = result.data;
        }
      });
    },
    getBalanceDetail() {
      let data = {
        page: this.page,
        limit: this.limit
      };
      this.$api.getBalanceList(data).then(res => {
        if (res.status) {
          this.tableData = res.data;
          this.totalPage = res.total;
        }
      });
    },
    handOrderMore(val) {
      this.page = val;
      this.getBalanceDetail();
    }
  },
  created() {
    this.getUserInfo();
    this.getBalanceDetail();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .detail {
    &-title {
      color: #757575;
      line-height: 30px;
      margin-top: 40px;
      font-weight: 550;
      border-bottom: 1px solid $border;
    }
    &-nodata {
      margin: 30px auto;
      text-align: center;
    }
  }
  .balance {
    color: #757575;
    display: flex;
    align-items: center;
    .money {
      font-size: 24px;
      font-weight: 550;
      color: #474e5d;
      margin-left: 10px;
    }
    .recharge {
      display: inline-block;
      width: 120px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: $theme-color;
      color: #fff;
      margin-left: 100px;
      cursor: pointer;
      a{
        display: block;
      }
    }
  }
}
</style>